import * as d3 from "./d3"
import * as chart from "./chart"
import debounce from "lodash/debounce"

const $w = d3.select(window)
const $kpi = d3.select(".kpi-header")
const $table = d3.select("#table")

export function draw ({ dataConfig, mapConfig }) {
  const config = { dataConfig, mapConfig }
  d3.select(".slider-box").html(drawSliders(dataConfig.AGEGROUPS))
  sliderHandler()
  Promise.all([d3.json(dataConfig.path), d3.json(mapConfig.path)])
  .then(([data, mapdata]) => {
    d3.selectAll(".noclick").classed("noclick", false)
    const geomap = chart.geomap({ mapdata, mapConfig })
    drawUpdate({ data, geomap, whatif: getsliderValues(), config })
    const dedrawUpdate = debounce(drawUpdate, 100)
    $w.on("update_slider", function() {
      dedrawUpdate({ data, geomap, whatif: d3.event.detail, config })
    }).on("sort_table", function() {
      drawTable({ data, config: {columns: dataConfig.table, ...d3.event.detail} })
    })
  })
}

function drawUpdate({ data, geomap, whatif, config }) {
  const {summary} = applySimulate({data, whatif})
  const { dataConfig } = config
  $kpi.html(chart.templateKPI({d: summary, config: dataConfig}))
  drawTable({ data, config: {columns: dataConfig.table} })
  geomap.update({ data })
}

function drawTable({ data, config }) {
  $table.html(chart.templateTable({table: data, config}))
  $table.selectAll("th").on("click", function() {
    let { col, order, sort } = this.dataset
    order = (sort==col)?(+order*-1):1
    $w.dispatch("sort_table", {detail: { sortBy: col, order }})
  })
}

function getsliderValues() {
  const value = {}
  d3.selectAll("input[type=range]").each(function () {
    value[this.dataset.key] = +this.value
  })
  return value
}

function sliderHandler() {
  d3.selectAll("input[type=range]").on("input", function () {
    const v = this.value, key = this.dataset.key
    d3.select(`[data-e="input"][data-key="${key}"] span`).html(v)
    const value = getsliderValues()
    $w.dispatch("update_slider", {detail: value})
  })
}

function applySimulate({ data, whatif, config }) {
  const cols = Object.keys(whatif)
  for (const col of cols) {
    data.forEach(d => {
      d[`_p_${col}`] = d[col]*whatif[col]/1000000
    })
  }
  data.forEach(d => {
    d["_p_total"] = cols.reduce((v,k)=>v+(d[`_p_${k}`]||0), 0)
    d["_p_diff"] = d["_p_total"] - d["BEDS"]
  })
  const places_at_risk = data.filter(d => d["_p_diff"] > 0)
  const shortfall = d3.sum(places_at_risk, d=>d["_p_diff"])
  const summary = {
    "BEDS": d3.sum(data, d=>d["BEDS"]),
    "TOTAL": d3.sum(data, d=>d["_p_total"]),
    "SHORTFALL": shortfall,
    "PLACESATRISK": places_at_risk.length,
    "POPATRISK": shortfall
  }
  return {summary, data}
}

function drawSliders(sliders) {
  return `
  ${sliders.map(d => `
  <div class="range-slider w-100 p-1 pt-md-2 border-top">
    <div class="align-items-center d-flex justify-content-between mb-n3 text-center">
      <div class="h6 text-uppercase">${d["column"]}</div>
      <div class="h5 pl-3" data-e="input" data-key="${d["column"]}">
        <span>${d["value"] || 100}</span><span class="pl-1 small">ppm</span></span>
      </div>
    </div>
    <input type="range" data-key="${d["column"]}"
      value="${d["value"] || 100}" min="${d["min"] || 0}" max="${d["max"] || 5000}" step="${d["step"] || 50}">
  </div>`).join('')}`
}
